import { createContext, useContext } from "react";
import { DEFAULT_CREATOR_THEME } from "./constants/Theme.constants";
import { ICreatorTheme } from "./theme.interface";

export const CreatorThemeContext = createContext<ICreatorTheme>(
  DEFAULT_CREATOR_THEME,
);

export const useCreatorThemeContext = () => useContext(CreatorThemeContext);
